// The project views the UI can be in. Single source of truth shared by the UI
// store and the URL `?view=` sync, so parsing an arbitrary query param and the
// store's type can never drift apart. There's no hub view: with no `?view=`,
// the project page computes a landing (first not-done step).
export const VIEW_MODES = [
  'idea',
  'market',
  'graph',
  'assumptions',
  'dialog',
  'synthesis',
  'capabilities',
  'validation',
  'pitch-deck',
] as const;

export type ViewMode = (typeof VIEW_MODES)[number];

// Type guard for untrusted strings (e.g. a hand-edited or stale `?view=` param).
// Lets callers fall back to the computed landing (first not-done step) instead
// of trusting the value.
export function isViewMode(value: string | null | undefined): value is ViewMode {
  return value != null && (VIEW_MODES as readonly string[]).includes(value);
}
